import { ComponentDataDestService } from '../component-data-dest.service';
import { environment } from '../../../environment/environment';
import { Observable, catchError, map } from 'rxjs';
import { Router } from '@angular/router';

export function deleteEvent(
  service: ComponentDataDestService,
  eventGuid?: string
): Observable<{ message?: string; deleted_count?: number }> {
  const router = service.injector.get(Router);
  const guid =
    eventGuid ||
    router.url.split('/').find((segment: string) =>
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(segment)
    );

  if (!guid) {
    throw new Error('Ingen gyldig event-GUID fundet');
  }

  const url = `${environment.apiUrl}/events/${guid}`;

  return service.http
    .patch<{ message?: string; deleted_count?: number }>(url, {
      event: { deleted: true, is_active: false },
    })
    .pipe(
      map((response) => response),
      catchError((error) => {
        console.error('[delete_event] Error:', error);
        const message =
          error?.error?.message || error?.message || 'Kunne ikke slette begivenheden';
        throw new Error(message);
      })
    );
}

export const delete_event = (
  service: ComponentDataDestService,
  data?: { event_guid?: string }
) => deleteEvent(service, data?.event_guid);
